module.exports = __webpack_public_path__ + "img/impact-in-action.1b8f4083.webp";